const loadbeeWidget = async (mfLoadbee: HTMLElement) => {
    const tabs: HTMLElement = document.getElementById('product-detail-tabs')!;
    const tabId = 'tab-loadbee';

    const handleOnChange = ({ detail }: CustomEvent<string>) => {
        if (detail === tabId) {
            window.dispatchEvent(new CustomEvent('onLoadbeeRender', { detail: true }));
            window.removeEventListener('onLoadbeeAvailable', handleLoadbeeAvailable);
            tabs.removeEventListener('onChange', handleOnChange);
        }
    };

    const initLoadBe = async () => {
        if (mfLoadbee && tabs) {
            window.addEventListener('onLoadbeeAvailable', handleLoadbeeAvailable);
        }
    };

    const handleLoadbeeAvailable = () => {
        const tab: HTMLElement | null = tabs.querySelector(`#${tabId}`);
        if (tab) {
            tabs.addEventListener('onChange', handleOnChange);
            tab.removeAttribute('hidden');
        }
    };

    await initLoadBe();
};

export default loadbeeWidget;
